/**
 * Sidebar — навигация.
 * Структура меню соответствует ARCHITECTURE.md §1.
 */
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { navSections } from './navConfig';
import { cn } from '@/lib/utils';
import { Sparkles } from 'lucide-react';

export function Sidebar() {
  const { t } = useTranslation();

  return (
    <aside className="w-64 bg-shell border-r border-surface-800 p-4 flex flex-col gap-6">
      <div className="flex items-center gap-2 px-2">
        <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-primary-500 to-accent-orange flex items-center justify-center shadow-glow-primary">
          <Sparkles className="w-5 h-5 text-white" />
        </div>
        <div>
          <div className="font-semibold text-sm">Content Studio</div>
          <div className="text-xs text-surface-500">AI Content Platform</div>
        </div>
      </div>

      <nav className="flex-1 flex flex-col gap-6">
        {navSections.map((section) => (
          <div key={section.title}>
            <div className="px-2 mb-1.5 text-xs uppercase tracking-wider text-surface-500">
              {t(`nav.${section.title}`)}
            </div>
            <div className="flex flex-col gap-0.5">
              {section.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-2 px-3 py-2 rounded-xl text-sm transition-colors',
                      isActive
                        ? 'bg-primary-500/15 text-primary-300'
                        : 'text-surface-400 hover:text-surface-100 hover:bg-surface-800/60',
                    )
                  }
                >
                  <item.icon className="w-4 h-4" />
                  <span>{t(`nav.${item.labelKey}`)}</span>
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>
    </aside>
  );
}
